import { Dispatch, FC, SetStateAction, useState } from "react";
import { Dropdown, Menu, Space, Table, Tag, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import { GetMasterPoint, UserSystemData } from "services/interface";
import { EllipsisOutlined } from "@ant-design/icons";

import { numberFormat } from "utils/nuberFormat";
import ModalEdit from "./ModalEdit";
//import ModalEditDeliveryPoint from "./ModalEditDeliveryPoint";
interface TableTransportationListProps {
  data: GetMasterPoint[] | undefined;
  onDeleteConfigs: (id: string) => void;
  limit: number;
  offset: number;
  setLimit: Dispatch<SetStateAction<number>>;
  setOffset: Dispatch<SetStateAction<number>>;
  total: string | undefined;
}

const testStatus = (status: boolean) => {
  if (status) {
    return "เปิด";
  } else {
    return "ปิด";
  }
};

const colorStatus = (status: boolean) => {
  if (status) {
    return "green";
  } else {
    return "red";
  }
};

const TableDeliveryPoint: FC<TableTransportationListProps> = ({
  data,
  onDeleteConfigs,
  limit,
  offset,
  setLimit,
  setOffset,
  total,
}) => {
  const [editData, setEditData] = useState<GetMasterPoint | undefined>();
  const [isMoadlEdit, setIsModalEdit] = useState<boolean>(false);

  const columns: ColumnsType<GetMasterPoint> = [
    {
      title: "ลำดับ",
      dataIndex: "index",
      align: "center",
      key: "index",
      render: (text, record, index) => index + 1,
      width: 50,
    },
    {
      title: "จำนวนเงินที่เติม",
      dataIndex: "money_amt",
      width: 250,
      render: (_text, record) => {
        return (
          <Typography.Link
            onClick={() => {
              setEditData(record);
              setIsModalEdit(true);
            }}
            style={{
              cursor: "pointer",
              fontWeight: "400",
              textDecoration: "underline",
            }}
          >
            {numberFormat(_text)}
          </Typography.Link>
        );
      },
    },
    {
      title: "จำนวน Point ที่ได้รับ",
      dataIndex: "point_amt",
      width: 250,
      render: (_text, record) => {
        return (
          <Typography.Link
            onClick={() => {
              setEditData(record);
              setIsModalEdit(true);
            }}
            style={{
              cursor: "pointer",
              fontWeight: "400",
              textDecoration: "underline",
            }}
          >
            {numberFormat(_text)}
          </Typography.Link>
        );
      },
    },
    {
      title: "สถานะ",
      dataIndex: "is_active",
      width: 100,
      render: (_text, record) => {
        return (
          <Tag color={colorStatus(record.is_active)}>
            {testStatus(record.is_active)}
          </Tag>
        );
      },
    },

    {
      title: "Action",
      dataIndex: "transection_code",
      align: "center",
      key: "transection_code",
      fixed: "right",
      width: 100,
      render: (_text, record) => (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <Space size="middle">
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item
                    key="1"
                    onClick={() => {
                      setEditData(record);
                      setIsModalEdit(true);
                    }}
                  >
                    แก้ไข
                  </Menu.Item>
                  <Menu.Item
                    key="2"
                    onClick={() => {
                      onDeleteConfigs(record.id);
                    }}
                  >
                    ลบ
                  </Menu.Item>
                </Menu>
              }
            >
              <div>
                <EllipsisOutlined />
              </div>
            </Dropdown>
          </Space>
        </div>
      ),
    },
  ];
  return (
    <div>
      <Table
        scroll={{ x: true }}
        size="middle"
        columns={columns}
        dataSource={data}
        pagination={{
          pageSize: limit,
          total: parseInt(total || "0"),
          onChange: (page, pageSize) => {
            setLimit(pageSize || 10);
            setOffset((page - 1) * pageSize);
          },
        }}
      />
      <ModalEdit
        editData={editData}
        isShow={isMoadlEdit}
        onClose={() => {
          setIsModalEdit(false);
        }}
      />
    </div>
  );
};

export default TableDeliveryPoint;
